/* import __COLOCATED_TEMPLATE__ from './mount-point.hbs'; */
var _class, _descriptor, _descriptor2, _descriptor3, _descriptor4;
function _initializerDefineProperty(target, property, descriptor, context) { if (!descriptor) return; Object.defineProperty(target, property, { enumerable: descriptor.enumerable, configurable: descriptor.configurable, writable: descriptor.writable, value: descriptor.initializer ? descriptor.initializer.call(context) : void 0 }); }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return typeof key === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (typeof input !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (typeof res !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) { var desc = {}; Object.keys(descriptor).forEach(function (key) { desc[key] = descriptor[key]; }); desc.enumerable = !!desc.enumerable; desc.configurable = !!desc.configurable; if ('value' in desc || desc.initializer) { desc.writable = true; } desc = decorators.slice().reverse().reduce(function (desc, decorator) { return decorator(target, property, desc) || desc; }, desc); if (context && desc.initializer !== void 0) { desc.value = desc.initializer ? desc.initializer.call(context) : void 0; desc.initializer = undefined; } if (desc.initializer === void 0) { Object.defineProperty(target, property, desc); desc = null; } return desc; }
function _initializerWarningHelper(descriptor, context) { throw new Error('Decorating class property failed. Please ensure that ' + 'transform-class-properties is enabled and runs after the decorators transform.'); }
// copied from https://github.com/squareup/dashboard/blob/rcohen/system-js-spike/frontend/%40dashboard/core-setup/addon/components/micro-frontend/mount-point.ts#L21-L42
import 'systemjs';
import Component from '@glimmer/component';
import { getOwner } from '@ember/application';
import { action } from '@ember/object';
import { inject as service } from '@ember/service';
import { tracked } from '@glimmer/tracking';
import { mountRootParcel } from 'single-spa';
import { getBrowserTimeZone } from '@dashboard/junk-drawer/utils/time';
import { getUrlParams } from '@square/dashboard-utilities/utils/window';
const API_PATH = '/balance-ui/api/dashboard-spa-manifest';
let MountPoint = (_class = class MountPoint extends Component {
  constructor(...args) {
    super(...args);
    _initializerDefineProperty(this, "status", _descriptor, this);
    _initializerDefineProperty(this, "environment", _descriptor2, this);
    _initializerDefineProperty(this, "router", _descriptor3, this);
    _initializerDefineProperty(this, "userInfo", _descriptor4, this);
    _defineProperty(this, "parcel", void 0);
    _defineProperty(this, "module", void 0);
  }
  get customProps() {
    const {
      merchantToken,
      employmentToken,
      personToken,
      countryCode
    } = this.userInfo;
    return {
      countryCode,
      employmentToken,
      merchantToken,
      pageName: this.args.pageName,
      personToken,
      timezone: getBrowserTimeZone(),
      unitToken: this.args.unitToken
    };
  }
  async setupApp(domElement) {
    const response = await fetch(this.endpoint);
    if (!response.ok) {
      this.status = 'failed';
      return;
    }
    const {
      app
    } = await response.json();
    const appSrc = `${app.cdnOrigin}/${app.main}`;
    this.module = await System.import(appSrc);
    if (this.module) {
      const parcelConfig = {
        bootstrap: this.module?.bootstrap,
        mount: this.module?.mount,
        unmount: this.module?.unmount
      };
      const parcelProps = {
        domElement,
        ...this.customProps
      };
      this.parcel = mountRootParcel(parcelConfig, parcelProps);
      await this.parcel.mountPromise;
    } else {
      this.status = 'failed';
    }
  }
  teardownApp() {
    if (this.parcel) {
      this.parcel.unmount();
    }
  }

  // In development, most users will not be running the integration
  // server for a micro frontend, so the default should be to use
  // its staging URL.
  // When a developer has the integration server running, they can
  // manually change useLocalIntegration to `true`.
  // For a developer that often wants integration mode, you can set the
  // INTEGRATION_BALANCE_UI env variable to 'true'. Note that
  // the env variable must be set before starting the dashboard dev server.
  get useLocalIntegration() {
    return this.config.dashboardMFE?.['balance-ui']?.enabled;
  }
  get config() {
    return getOwner(this).resolveRegistration('config:environment');
  }
  get previewBuild() {
    const params = getUrlParams();
    return params.get('balance-ui-branch');
  }
  get endpoint() {
    const {
      isDevelopment,
      isProduction,
      isSandbox,
      isTesting
    } = this.environment;
    const apiPath = this.previewBuild ? `${API_PATH}?previewBuild=${this.previewBuild}` : API_PATH;
    if (isTesting) {
      return apiPath;
    } else if (this.useLocalIntegration && isDevelopment) {
      const port = this.config.dashboardMFE?.['balance-ui'].localhostPort;
      return `http://localhost:${port}${apiPath}`;
    } else if (isProduction || isSandbox) {
      return `https://app.squareup.com${apiPath}`;
    } else {
      // testing, regular development, and staging all use staging
      return `https://app.squareupstaging.com${apiPath}`;
    }
  }
}, (_descriptor = _applyDecoratedDescriptor(_class.prototype, "status", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "environment", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor3 = _applyDecoratedDescriptor(_class.prototype, "router", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor4 = _applyDecoratedDescriptor(_class.prototype, "userInfo", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _applyDecoratedDescriptor(_class.prototype, "setupApp", [action], Object.getOwnPropertyDescriptor(_class.prototype, "setupApp"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "teardownApp", [action], Object.getOwnPropertyDescriptor(_class.prototype, "teardownApp"), _class.prototype)), _class);
export { MountPoint as default };